import axios from "axios";
import type { EstadoEvento, EventoSocio } from "../types/Evento.tsx";

const base =
  process.env.REACT_APP_BACK_URL ||
  `${window.location.protocol}//${window.location.hostname}:5000`;

type Headers = { headers?: Record<string, string> };

const auth = (token?: string): Headers =>
  token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {};

export type AcontecimientoAdmin = {
  acontecimiento_id: number;
  nombre: string;
  descripcion?: string | null;
  fecha: string;
  fecha_fin?: string | null;
  estado: EstadoEvento;
  cupo?: number | null;
  imagen_url?: string | null;
  ubicacion_id: number;
  categoria_id: number;
  ubicacion?: { ubicacion_id: number; nombre: string } | null;
  categoria?: { categoria_id: number; nombre: string } | null;
  socios?: EventoSocio[];
};

export type UbicacionEvento = { ubicacion_id: number; nombre: string };
export type CategoriaEvento = { categoria_id: number; nombre: string };

export type AcontecimientoPayload = {
  nombre: string;
  descripcion?: string | null;
  fecha: string;
  fecha_fin?: string | null;
  estado?: EstadoEvento;
  cupo?: number | null;
  imagen_url?: string | null;
  ubicacion_id?: number | null;
  ubicacion_nombre?: string | null;
  categoria_id?: number | null;
  categoria_nombre?: string | null;
  socios?: number[];
};

export const listarAcontecimientos = async (estado?: string, token?: string) => {
  const params: any = {};
  if (estado) params.estado = estado;
  const { data } = await axios.get<AcontecimientoAdmin[]>(
    `${base}/acontecimientos`,
    { ...(auth(token) || {}), params }
  );
  return data;
};

export const obtenerAcontecimiento = async (id: number, token?: string) => {
  const { data } = await axios.get<AcontecimientoAdmin>(
    `${base}/acontecimientos/${id}`,
    auth(token)
  );
  return data;
};

export const crearAcontecimiento = async (
  payload: AcontecimientoPayload,
  token?: string
) => {
  const { data } = await axios.post<AcontecimientoAdmin>(
    `${base}/acontecimientos`,
    payload,
    auth(token)
  );
  return data;
};

export const actualizarAcontecimiento = async (
  id: number,
  payload: Partial<AcontecimientoPayload>,
  token?: string
) => {
  const { data } = await axios.put<AcontecimientoAdmin>(
    `${base}/acontecimientos/${id}`,
    payload,
    auth(token)
  );
  return data;
};

export const eliminarAcontecimiento = async (id: number, token?: string) => {
  const { data } = await axios.delete(`${base}/acontecimientos/${id}`, auth(token));
  return data;
};

export const listarUbicaciones = async (token?: string) => {
  const { data } = await axios.get<UbicacionEvento[]>(
    `${base}/acontecimientos/ubicaciones`,
    auth(token)
  );
  return data;
};

export const listarCategorias = async (token?: string) => {
  const { data } = await axios.get<CategoriaEvento[]>(
    `${base}/acontecimientos/categorias`,
    auth(token)
  );
  return data;
};

export const listarSociosDeAcontecimiento = async (id: number, token?: string) => {
  const { data } = await axios.get<EventoSocio[]>(
    `${base}/acontecimientos/${id}/socios`,
    auth(token)
  );
  return data;
};

export const asignarSociosAcontecimiento = async (
  id: number,
  socioIds: number[],
  token?: string
) => {
  const { data } = await axios.post(
    `${base}/acontecimientos/${id}/socios`,
    { socioIds },
    auth(token)
  );
  return data;
};

export const desasignarSocioAcontecimiento = async (
  id: number,
  socioId: number,
  token?: string
) => {
  const { data } = await axios.delete(
    `${base}/acontecimientos/${id}/socios/${socioId}`,
    auth(token)
  );
  return data;
};
